<script setup>
import HiddenByPageActionRow from "@/components/actions/partials/HiddenByPageActionRow.vue";
import {useQuery} from '@tanstack/vue-query';
import axios from 'axios';
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import GroupedActionPanel from "@/components/actions/partials/GroupedActionPanel.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";

const {data: pages, isLoading} = useQuery({
  queryKey: ['hidden-actions-by-page'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/actions/hidden/by-page');

    return data.data;
  },
});
</script>

<template>
  <LoadingBlock v-if="isLoading" />

  <ZeroContent v-else-if="!pages.length">
    Looks like there are no hidden actions to display.
  </ZeroContent>

  <GroupedActionPanel v-else>
    <template #actions>
      <HiddenByPageActionRow
        v-for="page in pages"
        :key="page.id"
        :page="page"
      />
    </template>
  </GroupedActionPanel>
</template>
